import { useEffect, useRef, useState } from "react";
import { BaseCanvasRef } from "../components/BaseCanvas";
import { Canvas } from "../types/canvasTypes";
import { createFabricCanvas } from "../utils/canvasUtils";

const DEFAULT_OPTIONS = {
  width: 640,
  height: 360,
};

export function useInitBaseCanvas() {
  const baseCanvasRef = useRef<BaseCanvasRef>(null);
  const [canvas, setCanvas] = useState<Canvas>();

  useEffect(() => {
    const canvasRef = baseCanvasRef.current?.getCanvasRef();
    if (!canvasRef) return;

    const canvas = createFabricCanvas(canvasRef, DEFAULT_OPTIONS);
    setCanvas(canvas);

    return () => {
      setCanvas(undefined);
      canvas.dispose();
    };
  }, []);

  return { baseCanvasRef, canvas };
}
